import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Container } from './styled'
import EventTicketLogin from '../eventTicketLogin/view'
import EventTicketSignup from '../eventTicketSignup/view'
import EventTicketJoin from '../eventTicketJoin/view'

const EventOnboarding = ({event}) => {

  const [showLogin, setShowLogin] = useState(false)
  const isLogged = localStorage.getItem('token') ? true : false;

  const setLogin = (visible) => {
    setShowLogin(visible)
  };

  return (
    <Container>
      {!isLogged && showLogin && <EventTicketLogin setLogin={setLogin} event={event}/>}
      {!isLogged && !showLogin && <EventTicketSignup setLogin={setLogin}  event={event}/>}
      {isLogged && <EventTicketJoin setLogin={setLogin}  event={event}/>}      
    </Container>
  )
}

EventOnboarding.propTypes = {
  event: PropTypes.object,
}
EventOnboarding.defaultProps = {
  event: {}
}

export default EventOnboarding
